import React, { useEffect, useRef } from 'react'
import { BackHandler } from 'react-native'
import { RouteProp, useRoute } from '@react-navigation/native'
import { RootStackParamList } from '@navigation/types'
import { useChargeFee } from '@screens/NutritionistHub/hooks/useChargeFee.ts'
import { LoadingContainer } from '@screens/Common/containers/LoadingContainer.tsx'
import { useSecureScreen } from '@src/hooks/useSecureScreen'

export const FeePaymentScreen = () => {
  useSecureScreen()

  const route = useRoute<RouteProp<RootStackParamList, 'FeePaymentScreen'>>()
  const { videoCallId, feeProduct, appointmentKind, selectedSlotDate } = route.params
  const startedChargeFeeRef = useRef(false)
  const chargeFee = useChargeFee({
    videoCallId,
    feeProduct,
    appointmentKind,
    selectedSlotDate,
  })

  useEffect(() => {
    const subscription = BackHandler.addEventListener('hardwareBackPress', () => true)
    return () => subscription.remove()
  }, [])

  useEffect(() => {
    if (startedChargeFeeRef.current) {
      return
    }

    startedChargeFeeRef.current = true
    chargeFee()
  }, [chargeFee])

  return (
    <LoadingContainer
      loadingMessage="Processing your payment"
      secondaryMessage={`It might take up to 20 seconds.\nDo not close the app or go back.`}
    />
  )
}
